import UserSidebar from './component'

export default UserSidebar
